// Captura em capture-phase pra rodar antes do listener nativo do ícone.
const MOBILE_BREAKPOINT_QUERY = '(max-width: 749px)';

function isCartPage() {
  return (document.body.dataset.template || '').split('.')[0] === 'cart';
}

function handleCapturedClick(event) {
  const target = /** @type {HTMLElement} */ (event.target);
  const trigger = target.closest?.('.action__cart, [on\\:click="/open"]');
  if (!trigger) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  // Na página do carrinho não há drawer/painel: o carrinho já é a página.
  if (isCartPage()) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const eventName = window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches
    ? 'zrzs:quick-add:open-cart'
    : 'zrzs:quick-add:open-cart-desktop';
  document.dispatchEvent(new CustomEvent(eventName));
}

document.addEventListener('click', handleCapturedClick, { capture: true });
